import { render, staticRenderFns } from "./page_account.vue?vue&type=template&id=bf2484d4&"
import script from "./page_account.vue?vue&type=script&lang=js&"
export * from "./page_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports